// styles.ts
import styled from 'styled-components';
import { Typography } from 'antd';
const { Text } = Typography;

export const NoGridTableWrapper = styled.div`
  .ant-table-tbody > tr.no-border-row > td {
    border-bottom: none !important;
  }

  .ant-table-container {
    border: none !important;
  }

  .ant-table {
    border: none !important;
  }
`;

export const SummaryCardHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  .label {
    flex: 1;
    font-weight: 600;
  }
`;

export const SummaryTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr;
  border: 0.5 solid #bbb;
  margin-right: 40px;
`;

export const SummaryTableHeader = styled.div`
  border-top: 0.5px solid #bbb;
  border-bottom: 0.5px solid #bbb;
  padding: 10px;
  font-size: 15px;
`;

export const SummaryTitle = styled.div`
  margin-bottom: 2px;
  font-size: 18px;
  margin-left: 5px;
`;

export const SummarySum = styled.div`
  border-right: 0.5px solid #bbb;
  padding: 20px;
  align-self: stretch;
`;

export const SummarySpan = styled.span`
  min-width: 60px;
  text-align: left;
`;

export const SummaryDigit = styled.div`
  font-size: 32px;
`;

export const PieChartDiv = styled.div`
  /* border: 0.5px solid #ddd; */
  padding: 10;
  display: flex;
`;

export const CDNInfoDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
`;

export const CNDNameDiv = styled.div`
  margin-right: 6px;
  width: 10px;
  height: 10px;
  border-radius: 2;
`;

export const CDNText = styled(Text)`
  transition: background-color 0.3s ease;
  padding: 0 4px;
  min-width: 80px;
`;
